import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import {useUserSettingsSitesGroup} from "../@hooks";

export default function UserSettingSitesGroupTabButton() {
    const { handleSetSitesGroupFormData } = useUserSettingsSitesGroup()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetSitesGroupFormData}
    >
        Define Sites Group
    </ButtonLoadingSeeker>
}